import { type TableCellProps } from '@shared/components';
import { TableHeader, type TableHeaderRow } from '@shared/table-generator';

function getQBankStructureTable(): TableHeaderRow[] {
  const moreActionColumn: TableCellProps | undefined = {
    children: '',
    align: 'center' as const,
    rowSpan: 1,
    width: 48,
  };

  return [
    {
      children: [
        {
          id: 'subject',
          children: 'วิชา',
          align: 'center',
          rowSpan: 1,
        },
        {
          id: 'refCode',
          children: 'QSource',
          align: 'center',
          rowSpan: 1,
          width: 120,
        },
        {
          id: 'totalQuestion',
          children: 'จำนวนข้อ',
          align: 'center',
          rowSpan: 1,
          width: 120,
        },
        moreActionColumn,
      ],
    },
  ];
}

export default function QBankStructureTableHeader() {
  const columns = getQBankStructureTable();

  return (
    <TableHeader
      columns={columns}
      slotProps={{
        tableHeader: {
          sx: (theme) => ({
            bgcolor: theme.palette.common.black,
            borderColor: theme.palette.grey[300],
            border: 'none',
          }),
        },
        tableHeaderRow: {
          sx: {
            ':first-of-type': {
              'th:last-of-type': {
                borderRight: 'none',
              },
            },
            ':last-of-type > th': {
              borderTop: '1px solid',
              borderColor: (theme) => theme.palette.grey[300],
            },
          },
        },
        tableHeaderCell: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            padding: theme.spacing(3),
            borderRight: '1px solid',
            borderBottom: 'none',
            borderColor: theme.palette.grey[300],
          }),
        },
      }}
    />
  );
}
